<template>
    <card>
        <label>{{ $t('system.settings.fields.categories') }}</label> <br>


        <TableActionHeader
            @filterChange="onFilterChange" 
            :selectOptions="categories" 
            :selected="statusFilter"
            @filterSelect="onFilterSelect"
            :newButton="false"
            >
        </TableActionHeader>

        <b-table
            ref="settingsTable"
            responsive="sm" 
            striped 
            hover 
            selectable 
            select-mode="single" 
            @row-selected="onRowSelected"
            :items="displayItems" 
            :fields="fields" 
            :per-page="perPage" 
            :current-page="currentPage"
            :filter="filter"
            @filtered="onFiltered">
        </b-table>

        <TablePagination 
            :total-rows="totalRows" 
            :per-page="perPage"
            :currentPage="currentPage" 
            @pageChange="onPageChange">
        </TablePagination>
    </card>
</template>

<script>
import settings from '@/store/system/settings'


export default {
    name: "SettingsTable",
    data: function() {
            return {
                perPage: 15,
                currentPage: 1,
                filteredRows: 1,
                filteredDisplays: [],
                filter: "",
                statusFilter: "ALL",
                lastSelected: null,
                reopenedDetails: false
            }
        },
    computed: {
        fields(){
            return [
                { key: "name", label: this.$t('system.settings.fields.name'), sortable: true },
                { key: "value", label: this.$t('system.settings.fields.value') },
                // { key: "category", label: this.$t('system.settings_view.fields.category'), sortable: true},
            ]; 
        },
        items(){
            var settingsList = this.$store.state.settings.settingsList
            if(settingsList == null || !Array.isArray(settingsList))
                return [];

            return settingsList.map(setting => {
                    //boolean type settings with values 1 and 0 needs to be converted to true and false to correctly show it in checkbox
                    if(setting.type == 'boolean'){
                        if(setting.value == 1) setting.value = true
                        if(setting.value == 0) setting.value = false
                        return setting;
                    }
                    return setting;
                });
        },
        displayItems(){
            var settingsList = this.$store.state.settings.settingsList;
            if (!Array.isArray(settingsList)) {
                return [];
            }
            if (this.statusFilter == "ALL")
                return settingsList;
            return settingsList.filter(item => {
                    if(item.category)
                        return item.category.map(cat => cat.toLowerCase()).includes(this.statusFilter.toLowerCase());
                    return false;
                });
        },
        categories(){
            var list = this.$store.state.settings.categoriesList;
            var result = [];
            result.push({"id": "ALL", "label": this.$t("system.settings.categories.all")});
            if(list)
                list.forEach(item => {
                    result.push({"id": item, "label": this.$t("system.settings.categories." + item)})
                })
            return result;
        },
        totalRows() {
            if (!this.filter) {
                if(this.displayItems)
                    return this.displayItems.length;
                return 0;
            }
            return this.filteredRows;
        },
    },
    watch: {
        statusFilter() {
            this.currentPage = 1;
        },
        items: async function(){
            if(this.$refs.settingsTable){
                await this.$refs.settingsTable.refresh();
                if(this.lastSelected != null){
                    var index = this.items.findIndex(i => i.id == this.lastSelected.id);
                    if(index > -1){
                        this.reopenedDetails = true;
                        await this.$refs.settingsTable.selectRow(this.items.findIndex(i => i.id == this.lastSelected.id))
                    }
                }else
                    this.$refs.settingsTable.clearSelected()
            }
        }
    },
    beforeCreate: function() {
        if (!this.$store.state.settings) {
            this.$store.registerModule("settings", settings);
        }
        this.$store.dispatch('settings/getSettingsList');
        this.$store.dispatch('settings/getCategoriesList');
    },
    methods: {
        onFilterChange(filter) {
            this.currentPage = 1;
            this.filter = filter;
        },
        onFilterSelect(id){
            this.statusFilter = id;
        },
        onFiltered(filteredItems) {
            this.filteredRows = filteredItems.length;
            this.currentPage = 1;
        },
        onPageChange(page) {
            this.currentPage = page;
        },
        onRowSelected(items) {
            if (items[0]){
                this.lastSelected = items[0];
                this.$emit('onItemSelected', items[0], this.reopenedDetails);   
            }     
            else{
                this.$emit('onItemSelected', null, this.reopenedDetails);
            }
            this.reopenedDetails = false;
        },
    }
}
</script>